import type { ChartColorRef } from './types'

export const stackedBarLineChartConfig = {
  barmode: 'stack' as const,
  barWidth: 0.4,
  bargap: 0.3,
  hovermode: 'x unified' as const,

  line: {
    width: 2.5,
    shape: 'spline' as const,
    smoothing: 1.2,
    markerSize: 5,
    mode: 'lines+markers' as const,
    /** Used when `lineSeries.color` is not provided. */
    defaultColor: 'info' as ChartColorRef,
  },

  defaultStackColors: [
    'success',
    'tertiary',
    'primary',
    'secondary',
    'quaternary',
    'warning',
    'error',
    'info',
  ] as ChartColorRef[],

  colors: {
    title: 'textSecondary' as ChartColorRef,
    text: 'text' as ChartColorRef,
    grid: 'border' as ChartColorRef,
    legend: 'text' as ChartColorRef,
  },

  layout: {
    margins: { withTitle: { t: 40, r: 20, b: 40, l: 60 }, withoutTitle: { t: 10, r: 20, b: 40, l: 60 } },
    yTickformat: ',.0f',
    showXGrid: false,
    showYGrid: true,
  },

  legend: {
    orientation: 'h' as const,
    y: -0.2,
    x: 0.5,
    xanchor: 'center' as const,
  },

  marker: {
    lineWidth: 0,
  },

  defaults: {
    height: '100%' as const,
    width: '100%' as const,
    minHeight: '200px',
  },

  loadingMessage: 'Loading chart data...',
  emptyMessage: 'No data available',
} as const
